// Every other feature is recorded in the ledger but never charged.
export const AI_BILLABLE_FEATURES = [
    'agent',
    'deep-research',
    'agent-subtask',
    'compaction',
    'data-app',
];
const BILLABLE_FEATURE_SET = new Set(AI_BILLABLE_FEATURES);
export const isAiBillableFeature = (value) => BILLABLE_FEATURE_SET.has(value);
// Where the call's thread was created, never the request that continues it.
export const AI_USAGE_CHANNELS = [
    'web',
    'slack',
    'embed',
    'api',
    'mcp',
    'evals',
    'scheduler',
    'data_app',
];
const USAGE_CHANNEL_SET = new Set(AI_USAGE_CHANNELS);
export const isAiUsageChannel = (value) => USAGE_CHANNEL_SET.has(value);
//# sourceMappingURL=billable.js.map